import { ESharedFunction } from "motw_core/Enums/ESharedFunction";
import * as React from "react";
import { ShareState } from "../../../../services/UI/State/ShareState";
import { StyleClass } from "../../Styles/CSS";
import { ShowBroadStateSelectorHUD } from "source/app/presentation/Shared/ActivePanel/BroadStateSelectors/HUD/ShowBroadStateSelectorHUD";
import { GetAveragePercent } from "source/app/presentation/Shared/ActivePanel/BroadStateSelectors/HUD/Helpers/GetAveragePercent";

export function DisplayBroadStateSelectors() {
    const [keyValueUpdateTime, setKeyValueUpdateTime] = React.useState<string>(
        ""
    );

    ShareState(
        ESharedFunction.BroadStateSelectors_keyValueUpdateTime,
        keyValueUpdateTime,
        setKeyValueUpdateTime
    );

    const [averagePercent, setAveragePercent] = React.useState<
        number | undefined
    >(undefined);

    React.useEffect(() => {
        const averagePercent = GetAveragePercent();
        setAveragePercent(averagePercent);
    }, [keyValueUpdateTime]);

    const styleClass = StyleClass(`DisplayBroadStateSelectors`, {
        textAlign: `center`,
        position: `relative`,
        margin: `80px 0`,
    });

    return (
        <div className={styleClass}>
            <ShowBroadStateSelectorHUD averagePercent={averagePercent} />
        </div>
    );
}

